import Page from "webPage/Page";
import Gallery from "webPage/Gallery";
import showBgElements from "util/showBgelements";
import Track from "util/Track";

Page.register('single-post', () => {
    showBgElements();

    $(window).on('resize', showBgElements);

    let $gallery = $('.js-gallery');

    if ($gallery.length > 0) {
        new Gallery($gallery, {
            itemClass:          "gallery__main-image",
            pipClass:           "gallery__pagination-item",
            navigateClass:      "js-navigate",
            pipsClass:          "js-pips",
            itemsClass:         "js-items",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  0,
        });
    }

    let $track = $(".js-track-wrap");

    if ($track.length > 0) {
        new Track($track, {
            classes: {
                block: "slider",
            },
        });
    }
});
